import Vue from "vue";

export default {
  login(state, { user, session }) {
    Vue.set(state, "session", session);
    Vue.set(state, "user", user);
  },
  logout(state) {
    Vue.set(state, "session", null);
    Vue.set(state, "user", null);
  }
};
